<template>
  <div class="breadcrumb-area pos-relative w-100">
    <h1 class="mb-3">Lịch sử thông tin nhận hoá đơn</h1>
    <div class="btn-group float-right">
      <button class="font-medium f12 btn btn-outline-secondary" @click="$router.back()">
        Quay lại
      </button>
    </div>
    <p v-if="!historyData">Không có dữ liệu</p>
    <template v-else>
      <p>
        Thời gian: <b>{{ historyData.createdTime | formatDate('DD/MM/YYYY HH:mm:ss') }}</b>
      </p>
      <p>
        Người thao tác: <b>{{ historyData.creator.name + ' - ' + historyData.creator.email }}</b>
      </p>
      <div class="row mt-2">
        <div class="col-sm-6">
          <div class="form-detail">
            <h1 class="w-100">Thông tin ban đầu</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Tên Công ty<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ historyData.oldInvoiceMcName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Địa chỉ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ historyData.oldInvoiceMcAddress }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã số thuế<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ historyData.oldInvoiceMcBusinessNumber }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Họ và tên<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ historyData.oldInvoiceMcContactName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Chức vụ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">
                  {{ historyData.oldInvoiceMcContactPosition }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label">Email<span class="float-right">:</span></label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ historyData.oldInvoiceMcEmail }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Số điện thoại<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ historyData.oldInvoiceMcMobile }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-detail">
            <h1 class="w-100">Thông tin chỉnh sửa</h1>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Tên Công ty<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ historyData.invoiceMcName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Địa chỉ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ historyData.invoiceMcAddress }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Mã số thuế<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ historyData.invoiceMcBusinessNumber }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Họ và tên<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ historyData.invoiceMcContactName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Chức vụ<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ historyData.invoiceMcContactPosition }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label">Email<span class="float-right">:</span></label>
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ historyData.invoiceMcEmail }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-sm-4 col-form-label"
                >Số điện thoại<span class="float-right">:</span></label
              >
              <div class="col-sm-8">
                <p class="form-control-plaintext f12">{{ historyData.invoiceMcMobile }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        historyData: null,
      }
    },
    created() {
      this.historyData = this.$route.params?.historyData ?? null
    },
  }
</script>

<style lang="scss" scoped></style>
